// @flow
import cn from 'classnames';
import React from 'react';

import type { CustomButtonStyles } from '../../CallToAction';
import type { CustomButtonComponent } from '@site-builder/common/src/flow-types/components';
import type { FiveSymbolLocale } from '@site-builder/common/src/types/locale'
import type { Subscription } from '@site-builder/common/src/types/model/subscription';

import { addScriptData } from '../../../../reducers/modules/site-builder/scripts';
import { generateSubscriptionButtonText } from '../../../../utils/render-subscriptions';

type Props = {|
  button: CustomButtonComponent,
  theme: CustomButtonStyles,
  buttonId: string,
  onClick: Function,
  blockType: string,
  subscriptionPlans: Subscription[],
  isSubscriptionLoading: boolean,
  isServerSideRender: boolean,
  locale: FiveSymbolLocale,
  addScriptData: typeof addScriptData
|};

const SubscriptionButton = ({
  button, theme, buttonId, onClick, blockType, subscriptionPlans, isSubscriptionLoading, isServerSideRender, addScriptData, locale
}: Props) => {
  const subscriptionExternalId = button.value.buy.id;
  const selectedSubscription = subscriptionPlans.find(subscription => subscription.external_id === subscriptionExternalId);
  const buttonText = generateSubscriptionButtonText(selectedSubscription, locale);

  if (isServerSideRender && selectedSubscription && addScriptData) {
    addScriptData('subscriptionPurchase', selectedSubscription);
  }

  return (
    <>
      <div
        role='button'
        tabIndex={0}
        onKeyDown={() => {}}
        id={buttonId}
        className='ui-site-calltoaction ui-site-calltoaction--subscription xl_auth'
        style={theme}
        onClick={onClick}
        data-button-type='subscription' // attribute is used to find button handler in landing
        data-external-id={subscriptionExternalId}
        data-xa-method='elementClick'
        data-xa-name='subscription_button'
        data-xa-extra={JSON.stringify({
          id: subscriptionExternalId,
          block: blockType
        })}
      >
        <div
          className={cn('ui-site-calltoaction__text', { 'is-preloader': isSubscriptionLoading })}
          dangerouslySetInnerHTML={{ __html: buttonText }} // eslint-disable-line
        />
      </div>
      <button
        className='ui-site-calltoaction ui-site-calltoaction--configuration hidden'
        data-subscription-configuration-btn
        data-xa-method='elementClick'
        data-xa-name='configuration_subscription_button'
      >
        <span className='ui-site-calltoaction__text' />
      </button>
    </>
  );
};

export default SubscriptionButton;
